import { Injectable } from '@angular/core';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { HttpClient } from '@angular/common/http';
import { NetworkService } from '../../service/network.service';
import { CrowdCountDensityAlert } from '../../model/crowd-flow-alert';

@Injectable({
  providedIn: 'root'
})
export class AkitaHTTPCrowdCountDensityAlert extends GenericAkitaHTTPService<CrowdCountDensityAlert> {
  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'CrowdCountDensityAlert',
        options: 'keyValues',
        limit: '50'
      }
    };
    super(http, networkService, '/v2/entities/', 'CrowdCountDensityAlert', options);
  }
}
